import React, { useContext } from 'react';
import AppContext from 'contexts/appContext';
import { useTranslation } from 'react-i18next';


export default function ChartConfig(props) {

    const { appState } = useContext(AppContext);
    const { t } = useTranslation();

    const changeChartDimention = (dimention) => {
        props.setDimention(dimention);
    }

    return (
        <>
            <div className='chart-config'>
                <p>Edit chart metrics: </p>
                <ul id='chartConfig' className='list-group formmenu formmenu-open'>
                    {
                        props.chartDimentions.map((element, i) => {
                            return (<li key={i} className='list-group-item formmenu-child' onClick={() => changeChartDimention(element.title)}>
                                <div className='row'>
                                    <div className='col-10 formmenu-label'>{t(element.title)}&nbsp;({element.sign})</div>
                                    <div className='col-2 text-right'>
                                        <div className='checkradio checkradio-success'>
                                            <label className='checkradio-label' style={{ color: props.activeDimention === element.title ? '#5cb85c' : appState.theme === 'nav-theme' ? '#828282' : '#cbcbcb' }}>
                                                <i className='icons8-ok' />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </li>)
                        })
                    }
                </ul>
            </div>
        </>
    );

}